module.exports = __webpack_public_path__ + "img/pr-7.657a5029.png";